import { CheckBox } from './components/CheckBox';

import { QuotePricing } from './businessLogic/QuotePricing';
import { OldQuotePricing } from './businessLogic/OldQuotePricing';

export default {
  CheckBox,
  QuotePricing,
  OldQuotePricing
};

export {
  CheckBox,
  QuotePricing,
  OldQuotePricing
};